import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../components/Base';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "Divider-root_19iN1",
  "spreadEqual": "Divider-spreadEqual_2oSTJ"
};
var separatorStyles = {
  "top": "Separator-top_1Xr7Z",
  "right": "Separator-right_1XxB-",
  "bottom": "Separator-bottom_3ONff",
  "left": "Separator-left_S7AIK",
  "bottomToRight": "Separator-bottomToRight_3gEo7"
};
function Divider({
  direction = 'row',
  children,
  className,
  top,
  right,
  bottom,
  left,
  spread,
  ...extraProps
}) {
  const childClasses = {
    [separatorStyles.top]: top,
    [separatorStyles.right]: right || direction === 'row',
    [separatorStyles.bottom]: bottom || direction === 'column',
    [separatorStyles.left]: left,
    [separatorStyles.bottomToRight]: direction === 'columnToRow',
    [styles.spreadEqual]: spread === 'equal'
  };
  return /*#__PURE__*/_jsx(Base, {
    flex: true,
    flexGrow1: true,
    flexRow: direction === 'row',
    flexCol: direction === 'column',
    flexColToRow: direction === 'columnToRow',
    className: clsx(styles.root, className),
    ...extraProps,
    children: React.Children.toArray(children).map(child => /*#__PURE__*/React.cloneElement(child, {
      className: clsx(childClasses, child.props.className)
    }))
  });
}
export default Divider;